export class TileFlip {
  static initTileFlip(itemCls: string): void {
    let tileElements: JQuery<HTMLElement> = jQuery(`.${itemCls}`);

    // Adds event listeners on the tile for flipping the tile when hovered.
    tileElements
      .hover((event: JQuery.Event): void => {
        jQuery(event.currentTarget).addClass('hover');
      })
      .mouseleave((event: JQuery.Event): void => {
        jQuery(event.currentTarget).removeClass('hover');
      })
      .on('touchstart', (event: JQuery.Event): void => {
        jQuery(event.currentTarget).toggleClass('hover');
      });

    // Flips when an element on the back of the tile is focused. Also flips when focus leaves the back of the tile. Allows for keyboard navigation.
    let tileBack: JQuery<HTMLElement> = jQuery(`.${itemCls} .card-back`);
    tileBack
      .focusin((event: JQuery.Event): void => {
        jQuery($(event.target).closest(`.${itemCls}`)).addClass('hover');
      })
      .focusout((event: JQuery.Event): void => {
        jQuery($(event.target).closest(`.${itemCls}`)).removeClass('hover');
      });
  }
}
